var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("story-header", {
        attrs: { post: _vm.post.activity_post, "edit-mode": _vm.editMode },
        on: { onPostUpdate: _vm.onPostUpdate },
      }),
      _vm._v(" "),
      _c("story-list", {
        attrs: {
          "story-resource": _vm.storyResource,
          "target-id": _vm.post.id,
          "edit-mode": _vm.editMode,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }